import getEvent from '../../../../Apis/event/getEvent'
import selectedOrgId from '../../../../utils/helpers/selectedOrgId'

const teamCalendarIdBreadcrumb = async (data) => {
  const { match, teamName, pairedOrgId } = data || {}
  const { eventId } = match.params

  const eventTitle = await getEvent({ eventId, orgId: pairedOrgId || selectedOrgId() }).then(
    (event) => event.title,
  )

  return [teamName ? teamName.toUpperCase() : '', 'CALENDAR', eventTitle.toUpperCase()]
}

export default teamCalendarIdBreadcrumb
